import React from 'react'
import { useTranslation } from 'react-i18next'
import { groupBy } from 'lodash'
import { BuildingFragment } from '../../../generated/graphql'
import { HourSeriesList } from '../../project-hour-series/HourSeriesList'
import { Section } from '../../common/Section'
import { reduceToSumOfItems } from '../../../util/array-utility'

type Props = {
  building: BuildingFragment
}

export function BuildingHourSeries({ building }: Props): React.ReactElement {
  const { t } = useTranslation()

  const hourSeriesList = building.demands.flatMap((demand) => demand.hourSeries)

  const seriesListByName = groupBy(
    hourSeriesList,
    (hourSeries) => hourSeries.name,
  )

  const summedSeriesByName = Object.entries(seriesListByName).map(
    ([name, seriesList]) => ({
      ...seriesList[0],
      name,
      hourSeries: seriesList
        .map((series) => series.values)
        .reduce(reduceToSumOfItems, []),
    }),
  )

  return (
    <Section title={t('building.tabs.basicInfo.hourSeries')}>
      <HourSeriesList hourSeries={summedSeriesByName} size="small" />
    </Section>
  )
}
